import doubleDigitize from 'src/filters/doubleDigitize';

function formatTime(value) {
  if (!value) return '';
  const datetime = new Date(value);
  const hours = datetime.getHours();
  const minutes = datetime.getMinutes();
  return `${doubleDigitize(hours)}:${doubleDigitize(minutes)}`;
}

export default formatTime;
